import { Certification } from '../types';
import { certifications } from '../data/portfolioData';

// import datoCMSClient from './datoCMSClient';

export async function getCertifications(): Promise<Certification[]> {
  return certifications;
}
